/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { labels } from '@umati/dashboard-common';

class Footer extends Component {
  render () {
    return (
      <footer className={'footer ' + (this.props.fixed ? 'footer-fixed' : 'footer-static')}>
        <nav>
          <Link to="/about">{labels.about}</Link>
          <Link to="/data-policy">{labels.dataPolicy}</Link>
          <span>{labels.copyright}</span>
        </nav>
      </footer>
    );
  }
}

export default Footer;
